module.exports = __webpack_public_path__ + "static/media/(000006).dc379238.jpg";